import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as LinkSVG } from "go-core/images/svg/actions/link.svg";
import FormatResourceStatus from "../../../../../../../../../components/Common/Formatters/FormatResourceStatus/FormatResourceStatus";
import { ReactComponent as HomeSVG } from "../../../../../../../../../images/svg/apps/homepage.svg";
import { ReactComponent as RemoveSVG } from "../../../../../../../../../images/svg/apps/remove-lg.svg";
import { ApplicationApi, ApplicationTemplateApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import AppIcon from "../AppIcon";
import AppStatus from "../AppStatus";

interface Props {
	configApp: ApplicationTemplateApi;
	appState: AppState | undefined;
	installedApp?: ApplicationApi;
	onHide: () => void;
}

const AppModalHeader = ({ configApp, appState, installedApp, onHide }: Props) => {
	const { t } = useTranslation();

	return (
		<Modal.Header className={"modal-header"}>
			<div className={"app-icon"}>
				<AppIcon app={configApp} />
			</div>
			<div className={"app-description"}>
				<div className={"app-description-header"}>
					<h5>{t(`enums.apps.providers.${configApp.provider}`)}</h5>
					<AppStatus status={appState?.app ? appState.app?.status : installedApp?.status} />
					{appState?.app && appState?.app.status !== "ENABLED" && (
						<FormatResourceStatus
							status={appState?.app.status === "NEW" ? "INACTIVE_APP" : appState?.app.status}
						/>
					)}
					{appState?.app.link && (
						<a href={appState?.app.link} target={"_blank"} rel="noreferrer">
							{appState?.app.name}
							<LinkSVG className="ms-1" />
						</a>
					)}
					<RemoveSVG className={"close-icon ms-auto"} onClick={onHide} />
				</div>
				<div className={"app-description-info text-muted"}>{configApp.short_description}</div>
				<div className={"app-description-info-more"}>
					<HomeSVG style={{ marginTop: "-3px" }} /> {t("common.word.created_by")}{" "}
					<a target={"_blank"} rel={"noreferrer"} href={configApp.owner_link}>
						{configApp.owner}
					</a>
				</div>
			</div>
		</Modal.Header>
	);
};

export default AppModalHeader;
